import React, { InputHTMLAttributes } from 'react';

import * as S from './styled';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
}

const RadioInput = ({
  id,
  label,
  checked,
  disabled,
  ...rest
}: Props) => (
  <S.Label htmlFor={id} checked={checked} disabled={disabled}>
    <S.Input
      id={id}
      type="radio"
      checked={checked}
      disabled={disabled}
      {...rest}
    />
    <S.Icon />
    {label}
  </S.Label>
);

export default RadioInput;
